import React from 'react'
import {Container, Row, Col} from "react-bootstrap";
import HubbleIQBlack from '../../../images/HubbleIQ_black.png'
import './navbar.scss'

const Navbar = () => (
  <>
    <Container>
      <Row>
        <Col className="navbar-container mt-3">
          <div className="logo-container mb-3">
            <a href='https://hubbleiq.com/' target='_blank'>
              <img src={HubbleIQBlack}/>
            </a>
          </div>
        </Col>
      </Row>
      <div className="divider"></div>
    </Container>
  </>
)

export default Navbar
